exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 992px) {\n.dropdown[data-v-06e8153d] {\n    max-width: 300px;\n}\n}", ""]);

// exports
